import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Support = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M20 10h-.005c-.149-4.312-3.568-7.871-7.75-7.996A7.937 7.937 0 0 0 6.43 4.258 7.931 7.931 0 0 0 4 10c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h1a1 1 0 0 0 1-1v-7c0-1.637.647-3.166 1.822-4.307a5.97 5.97 0 0 1 4.362-1.69C15.392 4.099 18 6.921 18 10.293V18c0 1.103-.897 2-2 2h-2a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h5c2.206 0 4-1.794 4-4 1.103 0 2-.897 2-2v-4c0-1.103-.897-2-2-2z", key: "k0" })));
});
Support.displayName = 'Support';
export var SupportDimensions = { height: 24, width: 24 };
